import React from 'react';
import ContactForm from "../forms/ContactForm";

function Contact() {
    return (
        <div>
            <ContactForm />
        </div>
    );
}

export default Contact;